import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

type TUseIsFieldValid = {
  isValid: boolean;
  error: string;
  name: string;
};

const useIsFieldValid = (fieldName: string): TUseIsFieldValid => {
  const [isValid, setisValid] = useState(false);
  const form = useFormContext();
  const { formState, getFieldState, watch } = form;
  const fieldState = getFieldState(fieldName, formState);

  const { isDirty, invalid } = fieldState;
  const isInvalid = !watch(fieldName) || invalid || !isDirty;

  const errorMessage = formState.errors[fieldName]?.message?.toString() ?? '';

  useEffect(() => {
    if (isInvalid) {
      setisValid(false);
      return;
    }
    setisValid(true);
  }, [form, isInvalid]);

  return {
    isValid,
    error: errorMessage,
    name: fieldName
  };
};

export default useIsFieldValid;
